import React from "react";
import emailjs from "emailjs-com";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import toast, { Toaster } from "react-hot-toast";

const ContactForm = () => {
  const serviceId = "service_wvid1fc";
  const templateId = "template_9cooww9";
  const publicKey = "TDl247kGxdH9VivuP";

  const initialValues = {
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  };

  const validationSchema = yup.object({
    name: yup
      .string()
      .min(2, "Too Short!")
      .max(30, "Too Long!")
      .required("Name is required"),
    email: yup
      .string()
      .email("Invalid Email Format")
      .test("complete-domain", "Invalid Email Address", (value) => {
        return /@.+\..+/.test(value);
      })
      .required("Email is required"),
    subject: yup
      .string()
      .min(3, "Subject should be at least 3 letters")
      .required("Subject is required"),
    phone: yup.number().required("Phone Number is required"),
    message: yup
      .string()
      .min(10, "Message should be at least 10 letters")
      .required("Message is required"),
  });

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const toastId = toast.loading("Sending...");

    const templateParams = {
      from_name: values.name,
      from_email: values.email,
      subject: values.subject,
      message: values.message,
      to_name: "EEAIO",
      from_phone: values.phone,
    };

    emailjs
      .send(serviceId, templateId, templateParams, publicKey)
      .then((response) => {
        if (response.status === 200) {
          toast.success(
            "We have received your message. Thank you for contacting us!",
            {
              id: toastId,
              duration: 5000,
            }
          );
          resetForm();
        } else {
          toast.error(
            "There was an error sending your message. Please try again.",
            {
              id: toastId,
            }
          );
        }
        setSubmitting(false);
      })
      .catch((error) => {
        toast.error(
          "There was an error sending your message. Please try again.",
          {
            id: toastId,
          }
        );
        setSubmitting(false);
      });
  };

  return (
    <>
      <Toaster position="bottom-right" reverseOrder={false} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ isSubmitting }) => (
          <div className="react-blog-form">
            <h2 className="contact-title">
              Questions? <br /> Feel free to contact us.
            </h2>
            <div id="blog-form" className="blog-form">
              <Form id="contact-form">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="back-input">
                      <Field
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Name"
                      />
                      <ErrorMessage
                        className="errorComp"
                        name="name"
                        component="div"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 pdl-5">
                    <div className="back-input">
                      <Field
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Email"
                      />
                      <ErrorMessage
                        className="errorComp"
                        name="email"
                        component="div"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="back-input">
                      <Field
                        id="subject"
                        name="subject"
                        type="text"
                        placeholder="Subject"
                      />
                      <ErrorMessage
                        className="errorComp"
                        name="subject"
                        component="div"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 pdl-5">
                    <div className="back-input">
                      <Field
                        id="phone"
                        name="phone"
                        type="number"
                        placeholder="Phone"
                      />
                      <ErrorMessage
                        className="errorComp"
                        name="phone"
                        component="div"
                      />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="back-textarea">
                      <Field
                        as="textarea"
                        id="message"
                        name="message"
                        placeholder="Message"
                      />
                      <ErrorMessage
                        className="errorComp"
                        name="message"
                        component="div"
                      />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <button
                      type="submit"
                      className="back-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Sending..." : "Submit"}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-arrow-right"
                      >
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default ContactForm;
